/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Card_Help_TextInputs */

const en_contact_card_help_text = /** @type {(inputs: Contact_Card_Help_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get help with your account or technical questions.`)
};

const es_contact_card_help_text = /** @type {(inputs: Contact_Card_Help_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén ayuda con tu cuenta o preguntas técnicas.`)
};

/**
* | output |
* | --- |
* | "Get help with your account or technical questions." |
*
* @param {Contact_Card_Help_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const contact_card_help_text = /** @type {((inputs?: Contact_Card_Help_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Card_Help_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_card_help_text(inputs)
	return en_contact_card_help_text(inputs)
});